import { Roles, SystemRole } from '../../utils';
import { AuthenticationHandler } from '../contracts/gateways';
import { Doctor, Specialty, User } from '../entities';
import { DoctorService } from './doctor.service';
import { SessionService } from './session.service';
import { UserService } from './user.service';

export class AuthService {
  constructor(
    private readonly authHandler: AuthenticationHandler,
    private readonly userService: UserService,
    private readonly doctorService: DoctorService
  ) {}

  async loginInWithEmailAndPassword(email: string, password: string) {
    const user = await this.authHandler.loginInWithEmailAndPassword(email, password);
    SessionService.deleteSession();
    SessionService.saveSession(user);
  }

  async logout() {
    await this.authHandler.logout();
    SessionService.deleteSession();
  }

  async signup({
    email,
    password,
    name,
    role,
    medicalCenter,
    specialty
  }: {
    email: string;
    password: string;
    name: string;
    role: SystemRole;
    medicalCenter?: string;
    specialty?: Specialty;
  }) {
    const { userId } = await this.authHandler.signup({
      email,
      password
    });
    const user: User = {
      id: userId,
      email,
      name,
      role
    };
    await this.userService.create(user);

    if (role === Roles.doctor && specialty && medicalCenter) {
      const doctor: Doctor = {
        id: user.id,
        name,
        specialty,
        medicalCenter,
        availableDays: []
      };
      await this.doctorService.create(doctor);
    }
  }
}
